/**
 * localStorage helpers for player identity (name + color) and per-game session
 * tokens. Per-game scoping ensures one device can rejoin multiple games.
 */

const IDENTITY_KEY = "unophone:identity";
const TOKEN_PREFIX = "unophone:token:";

export interface SavedIdentity {
  name: string;
  color: string;
}

export function getSavedIdentity(): SavedIdentity | null {
  try {
    const raw = localStorage.getItem(IDENTITY_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<SavedIdentity>;
    if (typeof parsed.name === "string" && typeof parsed.color === "string") {
      return { name: parsed.name, color: parsed.color };
    }
  } catch {
    // fall through
  }
  return null;
}

export function saveIdentity(id: SavedIdentity): void {
  localStorage.setItem(IDENTITY_KEY, JSON.stringify(id));
}

export function getToken(gameCode: string): string | null {
  return localStorage.getItem(TOKEN_PREFIX + gameCode);
}

export function saveToken(gameCode: string, token: string): void {
  localStorage.setItem(TOKEN_PREFIX + gameCode, token);
}

export function clearToken(gameCode: string): void {
  localStorage.removeItem(TOKEN_PREFIX + gameCode);
}

const MUTE_KEY = "unophone:muted";
export function getMuted(): boolean {
  return localStorage.getItem(MUTE_KEY) === "1";
}
export function setMuted(muted: boolean): void {
  localStorage.setItem(MUTE_KEY, muted ? "1" : "0");
}

const LAST_CODE_KEY = "unophone:last_code";
export function getLastCode(): string | null {
  return localStorage.getItem(LAST_CODE_KEY);
}
export function setLastCode(code: string): void {
  localStorage.setItem(LAST_CODE_KEY, code);
}
export function clearLastCode(): void {
  localStorage.removeItem(LAST_CODE_KEY);
}
